<template>
  <div>
    <Header :showProductTour="false" />
    <div id="notifications-body">
      <b-button
        v-show="isNotificationPrefsUngated"
        class="align-self-end"
        variant="link"
        size="sm"
        v-b-modal.notification-pref-modal
      >
        Notification Preferences
      </b-button>
      <NotificationPrefModal />
      <b-tabs class="align-self-start w-100">
        <b-tab title="RSS Feeds" active>
          <RssNotificationsSection />
        </b-tab>
        <b-tab title="Database Updates">
          <DocumentNotificationsSection />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DocumentNotificationsSection from '@/components/DocumentNotificationsSection';
import RssNotificationsSection from '@/components/RssNotificationsSection';
import NotificationPrefModal from '@/components/modals/NotificationPrefModal.vue';
import { isNotificationPrefsUngated } from '@/constants/gates';

export default {
  name: 'NotificationsPage',
  components: {
    Header,
    DocumentNotificationsSection,
    RssNotificationsSection,
    NotificationPrefModal,
  },
  created() {
    this.isNotificationPrefsUngated = isNotificationPrefsUngated;
  },
};
</script>

<style scoped>
#notifications-body {
  margin-top: 130px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: start;
}
</style>
